import { render, staticRenderFns } from "./SubMenus.vue?vue&type=template&id=598550f1&"
import script from "./SubMenus.vue?vue&type=script&lang=js&"
export * from "./SubMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports